import type { Dataset } from '~/constants'

/** True on the first visit to CalWaves from any other dataset this session. */
export function shouldShowWavesIntroOnDatasetChange(
  dataset: Dataset,
  prevDataset: Dataset,
  hasShownWavesIntroThisSession: boolean
): boolean {
  return dataset === 'waves' && prevDataset !== 'waves' && !hasShownWavesIntroThisSession
}
